// extracted by mini-css-extract-plugin
export default {"container":"Main_container__CVU1P","div2":"Main_div2__EhfxB","div3":"Main_div3__BZXUg","div1":"Main_div1__HoyxC"};